

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.changeQuantityButton = this.form.querySelector('button[name=change]')
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      //sticky用のsubmit
      const stickySubmit = document.querySelector(".js-sticky-product-submit")
      if(stickySubmit){
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        stickySubmit.addEventListener("click",function(){
          const triggerEvent = new Event('submit')
          this.form.dispatchEvent(triggerEvent)
        }.bind(this))
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.quantityInput = this.querySelector('.js-quantity__input');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const items = await this.getCartItem();
      let productSku = this.form.querySelector('input[name=sku]').value
      let variant = items.find(item => item.sku === productSku);

      const formData = new FormData(this.form);

      // TODO: 202402 kanehori add 購入制限の設定
      if (this.quantityInput.dataset.limit == 'true') {
        if (
          variant != undefined &&
          variant.quantity + Number(this.quantityInput.value) >
            this.quantityInput.max
        ) {
          this.handleErrorMessage('最大購入数を超えています。');
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('wl-modal').show(
            variant,
            this.quantityInput.max,
          );
          this.querySelector('.loading-overlay__spinner').classList.add(
            'hidden',
          );
          return;
        }
      }

      if (this.cart) {
        formData.append(
          'sections',
           this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      //イベントの商品は、SKUが同じになってしまうのでLineitemは別のまま
      if(variant != undefined && variant.product_type != 'Event') {
        let inputQuantity = 1;
        if (this.querySelector('.js-quantity__input') !== null) {
          inputQuantity = Number(this.querySelector('.js-quantity__input').value);
        }
        
        const body = {
          id: variant.id,
          quantity: variant.quantity + inputQuantity,
          sections: this.cart
          .getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        };

        const cartResponse = await $.post('/cart/change.js', body, null, 'json');
        
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        let cartItem = cartResponse.items.find(item => item.id === variant.id);
        cartItem.sections = cartResponse.sections;
        this.cart.renderContents(cartItem);
      } else {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id),
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              console.log(response);
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          }); 
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.innerHTML = errorMessage;
      }
    }

    async getCartItem(){
      const cart = await $.get({ url:'/cart.js', dataType:'json'});
      return await cart.items;
    }
  });
}
class WLModal extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector('.wl-modal');
    this.closeButton = this.querySelector('[data-close]');
    this.closeButton.addEventListener('click', this.close.bind(this));
    this.addEventListener('click', this.close.bind(this));
  }

  close() {
    this.classList.add('hidden');
  }

  show(product, limit) {
    this.querySelector('[data-wl-product-title]').innerHTML =
      product?.product_title;
    this.querySelector('[data-wl-quantity]').innerHTML = limit;
    this.classList.remove('hidden');
  }
}
customElements.define('wl-modal', WLModal);
